import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class OverlayColumn extends Component {
  static propTypes = {
    align: PropTypes.oneOf(['left', 'right']),
    children: PropTypes.node,
    style: PropTypes.object
  }

  static defaultProps = {
    align: 'left'
  }

  render() {
    const { align, children, style } = this.props

    return (
      <div className={align + '-column'} style={style}>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayColumn.js